import React from "react";
import PropTypes from "prop-types";

import { Grid } from "semantic-ui-react";

import TemplateCard from "../TemplateCard";

export function TemplatesColumns({ data, perRow, disabled }) {
  return (
    <Grid columns={perRow} style={{ width: "100%" }}>
      {data.map((t) => {
        return (
          <Grid.Column key={t.id}>
            <TemplateCard template={t} disabled={disabled} />
          </Grid.Column>
        );
      })}
    </Grid>
  );
}

TemplatesColumns.propTypes = {
  perRow: PropTypes.number,
  data: PropTypes.array,
  disabled: PropTypes.bool,
};

TemplatesColumns.defaultProps = {
  data: [],
  perRow: 3,
  disabled: false,
};

export default TemplatesColumns;
